import React from "react";
import { TableIcon, FIGMA_TABLE_ICON_SIZE } from "./helpers";
import { GridApi, Column } from "ag-grid-community";
export type TSorting = "asc" | "desc" | "none";

export const SortIcon = (direction: TSorting) => {
    let sortIcon: any = null;

    if (direction === "asc" || direction === "desc") {
        sortIcon = (
            <span className={`ag-header-icon ag-header-label-icon ag-sort-${direction}ending-icon`} aria-hidden="true">
                {TableIcon(direction === "asc" ? "fa-caret-up" : "fa-caret-down", FIGMA_TABLE_ICON_SIZE, false)}
            </span>
        );
    }

    return sortIcon;
};

export const ExpandIcon = ({ expanded, onClick }: { expanded: boolean; onClick: () => void }) => {
    const name = expanded ? "expanded" : "collapsed";

    return (
        <span
            className={`ag-header-icon ag-header-expand-icon ag-header-expand-icon-${name}`}
            aria-hidden="true"
            onClick={onClick}
        >
            {TableIcon(expanded ? "fa-caret-right" : "fa-caret-left", FIGMA_TABLE_ICON_SIZE, false)}
        </span>
    );
};

export const CustomHeaderCell: React.FC<{ label: any } & React.HTMLAttributes<HTMLSpanElement>> = ({
    label,
    children,
    ...rest
}) => {
    return (
        <div className="ag-cell-label-container">
            <div className="ag-header-cell-label" role="presentation" unselectable="on">
                <span className="ag-header-cell-text" role="columnheader" unselectable="on" {...rest}>
                    {label}
                </span>
                {children}
            </div>
        </div>
    );
};

interface CustomSortableHeaderProps extends IHeaderComponentFrameworkParams {
    renderLabel: (params: IHeaderComponentFrameworkParams) => any;
}

export class CustomSortableHeader extends React.PureComponent<CustomSortableHeaderProps, { sorting: TSorting }> {
    constructor(props: any) {
        super(props);

        this.state = { sorting: this.getSorting() };
    }

    // Подписка — при монтировании, а не в конструкторе: React вправе выбросить экземпляр,
    // не смонтировав его, или смонтировать повторно — отписка тогда не парная
    componentDidMount() {
        this.props.column.addEventListener("sortChanged", this.onSortChanged);
    }

    componentWillUnmount() {
        this.props.column.removeEventListener("sortChanged", this.onSortChanged);
    }

    render() {
        const { renderLabel, ...rest } = this.props;
        const sortIcon = rest.enableSorting ? SortIcon(this.state.sorting) : null;

        return <CustomHeaderCell onClick={this.setSort} label={renderLabel(rest)} children={sortIcon} />;
    }

    setSort = () => {
        const toggle: TStringMap<string> = {
            asc: "desc",
            desc: "asc",
            none: "asc",
        };

        const direction = toggle[this.state.sorting] as "asc" | "desc";

        // с версии 31 вместо setSortModel — applyColumnState; defaultState повторяет
        // прежнее поведение: сортировка остаётся только на этой колонке
        this.props.api.applyColumnState({
            state: [{ colId: this.props.column.getId(), sort: direction }],
            defaultState: { sort: null },
        });
    };

    getSorting = () => {
        if (this.props.column.isSortAscending()) {
            return "asc";
        }

        if (this.props.column.isSortDescending()) {
            return "desc";
        }

        return "none";
    };

    onSortChanged = () => {
        this.setState({ sorting: this.getSorting() });
    };
}

// то, что AG Grid передаёт компоненту заголовка; отдельного columnApi с версии 31 нет
export interface IHeaderComponentFrameworkParams<T = undefined> {
    context: T;
    api: GridApi;
    column: Column;
    enableSorting: boolean;
    displayName: string;
}
